import React, { useState, useEffect } from 'react'
import { MISSION_STATUS_ENUM, MISSION_ENUM_TYPES } from 'shared/constants'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { FilterSelect } from 'Components/Filter/FilterSelect'
import LiveMapSearchInput from './SearchInput'
import SubmitButton from 'Components/Form/SubmitButton'
import { styles } from './styled'
import injectStyles from 'react-jss'
import { getTimePresetsMessage } from './utils'

const MISSION_STATUS_OPTIONS = [
  {
    label: 'All',
    value: null,
  },
  {
    label: 'Booked',
    value: MISSION_STATUS_ENUM.BOOKED,
  },
  {
    label: 'Checked In',
    value: MISSION_STATUS_ENUM.CHECKED_IN,
  },
  {
    label: 'Cancelled',
    value: MISSION_STATUS_ENUM.CANCELLED,
  },
]

const MISSION_TYPE_OPTIONS = [
  {
    label: 'All',
    value: null,
  },
  {
    value: MISSION_ENUM_TYPES.HANDTOHAND,
    label: 'Hand to Hand',
  },
  {
    value: MISSION_ENUM_TYPES.LETTERBOX,
    label: 'Letterbox',
  },
]

export const TodayMission = "Today's missions"
export const LiveMissions = 'Live Missions'
export const YesterdayMissions = "Yesterday's missions"
export const TomorrowMissions = "Tomorrow's missions"

const TimePresets = [
  {
    value: TodayMission,
    label: TodayMission,
  },
  {
    value: LiveMissions,
    label: LiveMissions,
  },
  {
    value: YesterdayMissions,
    label: YesterdayMissions,
  },
  {
    value: TomorrowMissions,
    label: TomorrowMissions,
  },
]

export const DEFAULT_FILTERS = cityId => ({
  client: null,
  status: null,
  type: null,
  time: "Today's missions",
  tableSearch: '',
  cityId,
})

const LiveMapFilters = ({
  onChange,
  filters,
  clients,
  cities,
  classes,
  suggestions,
}) => {
  const [clientOptions, setClientOptions] = useState(null)

  useEffect(() => {
    if (clients) {
      const clientsConverted = clients.reduce((acc, client) => {
        acc[client.name] = client.id
        return acc
      }, {})

      const clientOptions = [
        {
          label: 'All',
          value: null,
        },
      ]
      for (const key in clientsConverted) {
        clientOptions.push({
          value: clientsConverted[key],
          label: key,
        })
      }

      setClientOptions(clientOptions)
    }
  }, [clients])

  const updateFilters = (type, value) => {
    const newFilters = {
      ...filters,
      [type]: value,
    }

    onChange && onChange(newFilters)
  }

  const updatePreset = value => {
    const newFilters = {
      ...DEFAULT_FILTERS(filters.cityId),
      tableSearch: filters.tableSearch,
      time: value,
    }

    onChange && onChange(newFilters)
  }

  return (
    <div>
      <div className={classes.liveMapFilterRow}>
        <h2 className={classes.liveMapHeader}>Live Map</h2>

        <div className={classes.filterGroup}>
          {cities && (
            <FilterSelect
              hasPrimaryText={false}
              label="City"
              name="cityId"
              options={cities}
              value={filters.cityId}
              onChange={(e, index, value) => {
                updateFilters('cityId', value)
              }}
              sorted={true}
            />
          )}

          <FilterSelect
            hasPrimaryText={false}
            label="Mission Type"
            name="type"
            options={MISSION_TYPE_OPTIONS}
            value={filters.type}
            onChange={(e, index, value) => {
              updateFilters('type', value)
            }}
            sorted={true}
          />
          {clientOptions && (
            <FilterSelect
              hasPrimaryText={false}
              label="Client"
              name="client"
              options={clientOptions}
              value={filters.client}
              onChange={(e, index, value) => {
                updateFilters('client', value)
              }}
              sorted={true}
            />
          )}
          <FilterSelect
            hasPrimaryText={false}
            label="Status Mission"
            name="status"
            options={MISSION_STATUS_OPTIONS}
            value={filters.status}
            onChange={(e, index, value) => {
              updateFilters('status', value)
            }}
            sorted={true}
          />
        </div>
      </div>

      <div className={classes.liveMapFilterRow}>
        <FilterBox>
          <LiveMapSearchInput
            placeholder="Search anything"
            searchHandler={value => {
              updateFilters('tableSearch', value)
            }}
            value={filters.tableSearch}
            suggestions={suggestions}
          />
        </FilterBox>
        <ButtonGroup
          disableElevation
          color="primary"
          className={classes.presetsGroup}
        >
          <p className={classes.timeMessage}>
            {getTimePresetsMessage(filters.time)}
          </p>
          {TimePresets.map(item => (
            <SubmitButton
              key={item.value}
              onClick={() => {
                updatePreset(item.value)
              }}
              value={item.label}
              variant={filters.time === item.value ? 'contained' : 'outlined'}
            />
          ))}
        </ButtonGroup>
      </div>
    </div>
  )
}

export default injectStyles(styles)(LiveMapFilters)



// WEBPACK FOOTER //
// ./src/Components/LiveMap/filters.js